<template>
  <div class="share" @click="onShare">
    <div
      class="share-hidden"
      :class="{ 'share-guide': isGuide }"
      @click.stop="onCloseGuide"
    >
      <img src="../assets/activity-share-guide.png" alt="" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isGuide: false
    }
  },
  methods: {
    onShare() {
      this.isGuide = true
    },
    onCloseGuide() {
      this.isGuide = false
    }
  }
}
</script>

<style lang="scss" scoped>
.share-hidden {
  display: none;
}
.share-guide {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
  padding: 0 5px 0 50px;
  img {
    width: 100%;
  }
}
</style>
